function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDungeonDelver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 56 56",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFBC81"
    },
    d: "M50,42.5c-2.972,0-5.433,2.163-5.91,5H44v-40H26.222L24,12.5l-2-5h-2.667L18,10.5l-1.2-3H12v40h-0.09 c-0.477-2.837-2.938-5-5.91-5c-3.314,0-6,2.686-6,6c0,3.286,2.642,5.951,5.918,5.996V54.5H12h3h9.778l2.222-5l2,5h2.667l1.333-3 l1.2,3H41h3h6.082v-0.004C53.358,54.451,56,51.786,56,48.5C56,45.186,53.314,42.5,50,42.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M50,42.5c3.314,0,6,2.686,6,6v-41c0-3.314-2.686-6-6-6s-6,2.686-6,6v41 C44,45.186,46.686,42.5,50,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M6,42.5c3.314,0,6,2.686,6,6v-41c0-3.314-2.686-6-6-6s-6,2.686-6,6v41C0,45.186,2.686,42.5,6,42.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M21.332,27.661C21.111,26.961,21,26.234,21,25.5c0-0.552-0.447-1-1-1s-1,0.448-1,1 c0,0.938,0.143,1.867,0.424,2.761c0.135,0.427,0.528,0.7,0.954,0.7c0.099,0,0.2-0.015,0.3-0.046 C21.205,28.749,21.498,28.188,21.332,27.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M24.972,32.137c-0.87-0.521-1.624-1.168-2.243-1.921c-0.349-0.426-0.978-0.489-1.407-0.138 c-0.427,0.351-0.488,0.981-0.138,1.408c0.764,0.931,1.692,1.727,2.759,2.366c0.161,0.097,0.339,0.143,0.514,0.143 c0.34,0,0.671-0.173,0.858-0.486C25.599,33.035,25.445,32.42,24.972,32.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M32.761,33.924C31.867,33.643,30.938,33.5,30,33.5c-0.766,0-1.526-0.085-2.262-0.254 c-0.54-0.128-1.074,0.212-1.198,0.751c-0.123,0.538,0.213,1.075,0.751,1.198C28.174,35.397,29.085,35.5,30,35.5 c0.734,0,1.461,0.112,2.161,0.332c0.1,0.031,0.2,0.046,0.3,0.046c0.426,0,0.819-0.273,0.954-0.7 C33.581,34.651,33.288,34.09,32.761,33.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M38.352,38.442c-0.639-1.065-1.435-1.993-2.366-2.759c-0.427-0.351-1.057-0.288-1.407,0.137 c-0.351,0.427-0.289,1.057,0.138,1.408c0.753,0.62,1.399,1.375,1.921,2.243c0.188,0.313,0.519,0.485,0.858,0.485 c0.175,0,0.353-0.046,0.514-0.143C38.482,39.53,38.636,38.916,38.352,38.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M39.695,41.791c-0.124-0.539-0.66-0.873-1.198-0.75c-0.539,0.124-0.875,0.66-0.751,1.199 C37.915,42.972,38,43.732,38,44.5c0,0.552,0.447,1,1,1s1-0.448,1-1C40,43.582,39.897,42.67,39.695,41.791z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#556080"
    },
    points: "23.707,18.207 22.293,16.793 20,19.086 17.707,16.793 16.293,18.207 18.586,20.5  16.293,22.793 17.707,24.207 20,21.914 22.293,24.207 23.707,22.793 21.414,20.5 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M33,12.5c0,0.552,0.447,1,1,1s1-0.448,1-1v-5h-2V12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M37,7.5v3c0,0.552,0.447,1,1,1s1-0.448,1-1v-3H37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M17,48.5c-0.553,0-1,0.448-1,1v5h2v-5C18,48.948,17.553,48.5,17,48.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#977C43"
    },
    d: "M21,51.5c-0.553,0-1,0.448-1,1v2h2v-2C22,51.948,21.553,51.5,21,51.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDungeonDelver);
export default __webpack_public_path__ + "static/media/dungeon_delver.76085ced90279a8e46ea34d53c57742c.svg";
export { ForwardRef as ReactComponent };